goog.module('yext.location.Select');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const helpers = goog.require('yext.location.helpers');

/**
 * Models a single select element field like custom Boolean and Single options
 * fields along with Closed and Location Type fields
 *
 * @constructor
 * @author MattJS (mattjs@yext.com)
 */
const Select = function($ctx) {
  this.$ctx = $ctx;
  this.initGumi();
  this.$select = $ctx.find('select');
  this.$displaySelect = $ctx.closest('.field-display');
  this.$indeterminate = $ctx.find('.js-field-indeterminate');
  this.$fieldValue = this.$ctx.find('.js-field-value');
  this.data = {
    value: this.$select.val(),
    displayValue: this.$displaySelect.data('displayValue'),
    indeterminate: this.$indeterminate.val() === 'true',
    displayIndeterminate: this.$displaySelect.find('.various').length > 0,
    timestamp: $ctx.find('.js-field-timestamp').val(),
  };

  this.labels = this.getLabels();
  this.storeValue();
  this.setFieldValue();
  this.bind();

  this.assetOrOriginal = true;
  this.originalValue = this.$select.val();
};

/**
 * @return {string} The field id
 */
Select.prototype.getId = function() {
  return this.$ctx.find('[name=field]').val();
};

/**
 * @return {boolean} True if there is more than one option
 */
Select.prototype.hasOptions = function() {
  return this.$select.find('option').length > 1;
};

/**
 * Find and initialize any gumi-based selects
 */
Select.prototype.initGumi = function() {
  var options = $.extend({}, yext.gumiConfig, {
    buttonClass: 'button-gray btn-dropdown',
    buttonTextOnly: false,
  });
  this.$ctx.find('.js-gumi-select').gumi(options);
};

/**
 * Iterate through select options to get labels to be used
 * in view mode
 */
Select.prototype.getLabels = function() {
  var labels = {};
  this.$select.find('option').each(function() {
    var $this = $(this);
    labels[$this.val()] = $this.html();
  });
  return labels;
};

/**
 * Get the display value of the field (view mode)
 */
Select.prototype.getDisplayValue = function(cannotEdit) {
  if (this.data.displayIndeterminate) {
    return helpers.variousContentMessage();
  } else if (!this.data.displayValue) {
    return helpers.emptyFieldMessage(cannotEdit);
  } else {
    return this.labels[this.data.displayValue];
  }
};

/**
 * Clear the field's value
 */
Select.prototype.clear = function() {
  this.set({
    value: '',
    indeterminate: false,
  });
};

/**
 * Set the select element value and trigger a change event
 *
 * @param {!Object} value
 */
Select.prototype.set = function(field) {
  this.data.value = field.value;
  this.data.displayValue = field.displayValue;
  this.data.displayIndeterminate = field.displayIndeterminate;
  this.data.indeterminate = field.indeterminate;
  if (field.timestamp) {
    this.data.timestamp = field.timestamp;
  }
  this.render();
};

/**
 * Renders the field in its current state
 */
Select.prototype.render = function() {
  if (this.data.value != this.$select.val()) {
    this.$select.val(this.data.value);
    this.$select.trigger('change');
  }
  this.$indeterminate.val(this.data.indeterminate);
  this.$ctx.find('.js-indeterminate-message').toggle(this.data.indeterminate);
  this.$ctx.find('.js-select-wrap').toggle(!this.data.indeterminate);
};

/**
 * Store the value so that it can be restored later
 */
Select.prototype.storeValue = function() {
  this.storedValue = {
    value: this.data.value,
    indeterminate: this.data.indeterminate,
    displayValue: this.data.displayValue,
    displayIndeterminate: this.data.displayIndeterminate,
  };
};

/**
 * Bind to the select's change event and publish a custom event
 */
Select.prototype.bind = function() {
  var self = this;

  this.$select.on('change', function() {
    self.data.value = self.$select.val();
    self.setSelectedOption();
    self.message('updated');
    $(self).trigger('update.list');
    $(self).trigger('update.struct');
    self.setFieldValue();
    self.updateAssetOrOriginal(false);
  });

  this.$ctx.find('.js-reset-select').click(function() {
    self.data.indeterminate = false;
    self.render();
    self.message('updated');
    $(self).trigger('update.list');
    $(self).trigger('update.struct');
    self.setFieldValue();
    self.updateAssetOrOriginal(false);
  });
};

/**
 * Set 'selected' attribute to true for the selected option in DOM tree
 */
Select.prototype.setSelectedOption = function() {
  var self = this;
  this.$select.find('option').each(function() {
    if (self.$select.val() === $(this).val()) {
      $(this).attr('selected', true);
    } else {
      $(this).attr('selected', false);
    }
  });
};

/**
 * Reset the field to the stored state
 */
Select.prototype.reset = function() {
  this.set(this.storedValue);
};

/**
 * Publish a message with the field as the context
 */
Select.prototype.message = function(msg) {
  $(this).trigger(msg);
};

/**
 * Returns the current value of the field
 *
 * @return {string} The field's value
 */
Select.prototype.getValue = function() {
  return this.data.value;
};

/**
 * Returns the field's current data
 *
 * @return {string} The field's data
 */
Select.prototype.getData = function() {
  return {
    value: this.data.value,
    indeterminate: this.data.indeterminate,
    timestamp: this.data.timestamp,
  };
};

/**
 * True if the field is empty
 */
Select.prototype.isEmpty = function() {
  return !this.data.value && !this.data.indeterminate;
};

/**
 * True if the field is indeterminate
 */
Select.prototype.isIndeterminate = function() {
  return !!this.data.indeterminate;
};

/**
 * @return {string} The field name
 */
Select.prototype.getName = function() {
  return this.$select.prop('name');
};

/**
 * Sets the default option to the first option of the dropdown
 */
Select.prototype.setDefaultOption = function() {
  this.$select.find('option:eq(0)')
    .prop('selected', true)
    .trigger('change');
};

/**
 * Returns form data if the field is contained by a form otherwise it returns
 * the name & value of the field
 *
 * @return {!Array} Name/value pairs for this field and optionally its containing form
 */
Select.prototype.getFormData = function() {
  if (this.$select[0].form) {
    return $(this.$select[0].form).serializeArray();
  }
  return [{
    name: this.getName(),
    value: this.getValue(),
  }];
};

/**
 * @return {string} label The option label
 */
Select.prototype.getLabel = function() {
  return this.labels[this.getValue()];
};

/**
 * @param {string} label
 * @param {string} value
 */
Select.buildOption = function(label, value) {
  return '<option value="' + value + '">' + label + '</option>';
};

/**
 * Sets a hidden input to the JSON value of this field
 */
Select.prototype.setFieldValue = function() {
  this.$fieldValue.val(yext.JSON.stringify(this.getJSONData()));
};

/**
 * Get the current state of the field as a JSON string
 *
 * @return {string} JSON string of field
 */
Select.prototype.getJSONData = function() {
  return {
    'value': this.data.value,
    'indeterminate': this.data.indeterminate,
    'timestamp': this.data.timestamp,
  };
};

/**
 * Update the asset or original flag.
 */
Select.prototype.updateAssetOrOriginal = function(fromAsset) {
  if (fromAsset || this.originalValue === this.$select.val()) {
    this.assetOrOriginal = true;
  } else {
    this.assetOrOriginal = false;
  }
};

/**
 * Type-ubiquitous function for checking assetOrOriginal flag.
 */
Select.prototype.checkAssetOrOriginalFlag = function() {
  return this.assetOrOriginal;
};

/**
 * Apply values to this field from an asset. Also set the assetOrOriginal flag to true.
 */
Select.prototype.applyAsset = function(fieldValues) {
  this.set(fieldValues);
  this.updateAssetOrOriginal(true);
};

/**
 * The after save function when this select is a child of a struct
 */
Select.prototype.setFromStruct = function(fieldValues, $display, $viewTemplate /* unused */, cannotEdit) {
  this.set(fieldValues);
  this.storeValue();
  $display.empty().append(this.getDisplayValue(cannotEdit));

  this.assetOrOriginal = true;
  this.originalValue = this.$select.val();
};

exports = Select;
